// Modification du fichier FolderBreadCrumb.styled.ts
import styled from 'styled-components'

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  overflow-x: auto;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    gap: 2px;
  }
`

export const Folder = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    &:not(:last-child):not(:first-child) {
      max-width: 100px;
    }
  }
`

export const BaseTitle = styled.span`
  cursor: pointer;
  color: var(--Foreground-Neutral-faded, #4d5874);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  white-space: nowrap;

  &:hover {
    color: var(--Foreground-Neutral, #14171f);
  }

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    color: var(--foreground-neutral, #14171f);
    font-size: 16px;
    font-weight: 500;
    line-height: 28px;
  }
`

export const ItemName = styled.span<{ isLast: boolean }>`
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
  font-weight: ${({ isLast }) => (isLast ? '500' : '400')};
  color: ${({ isLast }) => (isLast ? '#14171f' : '#4d5874')};
  cursor: ${({ isLast }) => (isLast ? 'default' : 'pointer')};
  white-space: nowrap; // Empêche le retour à la ligne

  &:hover {
    color: ${({ isLast }) => (isLast ? '#14171f' : '#14171f')};
  }

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    font-size: 16px;
    line-height: 28px;
    max-width: ${({ isLast }) => (isLast ? 'unset' : '80px')};
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const Separator = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    transform: scale(0.8);
  }
`
